export function isNullish<T>(val: T | null | undefined): val is null | undefined {
    return val === null || val === undefined;
}
